// Resolve approved times without changing the stored schedule.
export function resolvePayrollTime(shift, employeeData) {
  const approved = employeeData?.payrollTime;
  if (approved?.source !== "punched") return { shift, employeeData };
  return {
    shift: { ...shift, startTime: approved.startTime, endTime: approved.endTime },
    employeeData: { ...employeeData, breaks: approved.breaks ?? employeeData.breaks },
  };
}

// Arbetstid in both the schedule and time report is before deductions.
export function workTimeHours(shift, employeeData = shift.employeeData) {
  const resolved = resolvePayrollTime(shift, employeeData).shift;
  if (!resolved.startTime || !resolved.endTime) return 0;
  const parts = [resolved.startTime, resolved.endTime].flatMap((value) =>
    String(value).split(":").map(Number)
  );
  if (parts.length !== 4 || parts.some((value) => !Number.isFinite(value))) return 0;
  const [startHour, startMinute, endHour, endMinute] = parts;
  const minutes = endHour * 60 + endMinute - startHour * 60 - startMinute;
  return (minutes < 0 ? minutes + 1440 : minutes) / 60;
}

const time = (date) => `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

export function approvedPunchTime(sessions) {
  const rows = [...sessions].sort((a, b) => a.clockIn - b.clockIn);
  if (!rows.length || rows.some((row) => !row.clockIn || !row.clockOut || row.clockOut <= row.clockIn)) {
    throw new Error("Alla stämplingar för passet måste ha både in- och utstämpling.");
  }
  if (rows[rows.length - 1].clockOut - rows[0].clockIn >= 86400000) {
    throw new Error("Stämplingarna måste omfatta mindre än ett dygn.");
  }
  const breaks = [];
  rows.slice(1).forEach((row, index) => {
    const previous = rows[index];
    if (row.clockIn < previous.clockOut) throw new Error("Stämplingarna överlappar varandra.");
    if (row.clockIn > previous.clockOut) breaks.push({ startTime: time(previous.clockOut), endTime: time(row.clockIn) });
  });
  return {
    source: "punched", startTime: time(rows[0].clockIn), endTime: time(rows[rows.length - 1].clockOut),
    eventIds: rows.flatMap((row) => row.eventIds || []),
    // Multiple intervals already exclude clocked-out breaks.
    ...(rows.length > 1 ? { breaks } : {}),
  };
}
